<ng-container
  *flexyooLet="{
    isLoading: isLoading$ | async,
    quillDocumentId: quillDocumentId$ | async,
    quillDocumentStatus: quillDocumentStatus$ | async,
  } as data"
>
  @if (data.quillDocumentId) {
    <div class="fo-fill">
      {{ 'employee.user-agreement-sign.submitted-description' | translate }}
    </div>
    @if (data.quillDocumentStatus) {
      {{ 'employee.user-agreement-sign.status.title' | translate }}
      {{ 'employee.user-agreement-sign.status.' + data.quillDocumentStatus | translate }}
    }
    @if (data.quillDocumentStatus !== 'DECLINED') {
      <button
        class="sign-button fo-color-secondary"
        matButton="filled"
        [disabled]="data.isLoading"
        (click)="updateStatus(data.quillDocumentId)"
      >
        {{ 'employee.user-agreement-sign.update-status' | translate }}
      </button>
    }
  } @else {
    <div class="fo-fill">
      {{ 'employee.user-agreement-sign.description' | translate }}
    </div>
  }
  <button
    class="sign-button fo-color-secondary"
    matButton="filled"
    [disabled]="data.isLoading"
    (click)="sign()"
  >
    {{ 'employee.user-agreement-sign.sign-button' | translate }}
  </button>

  @if (data.isLoading) {
    <flexyoo-loader class="loader"></flexyoo-loader>
  }
</ng-container>
